import { cn } from '@/lib/utils'

type AvatarColor = 'navy' | 'amber' | 'emerald' | 'rose' | 'blue' | 'violet' | 'slate'

interface AvatarProps {
  name: string
  color?: AvatarColor
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const colorStyles: Record<AvatarColor, string> = {
  navy: 'bg-navy-700',
  amber: 'bg-amber-500',
  emerald: 'bg-emerald-500',
  rose: 'bg-rose-500',
  blue: 'bg-blue-500',
  violet: 'bg-violet-500',
  slate: 'bg-slate-400',
}

const sizeStyles = {
  sm: 'w-8 h-8 text-[10px]',
  md: 'w-10 h-10 text-xs',
  lg: 'w-12 h-12 text-sm',
}

export function Avatar({ name, color = 'slate', size = 'md', className }: AvatarProps) {
  const initials = name
    .split(' ')
    .map(w => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return (
    <div
      className={cn(
        'rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0',
        colorStyles[color],
        sizeStyles[size],
        className
      )}
    >
      {initials}
    </div>
  )
}
